import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo, useMemo } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './bazaarvoice-review-loading.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly reviewCount: number;
}
function BazaarvoiceReviewLoadingComponent(t0) {
  const $ = _c(10);
  const {
    reviewCount
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  let t1;
  if ($[0] !== reviewCount) {
    t1 = Array.from({
      length: reviewCount
    }, _temp);
    $[0] = reviewCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reviewSkeletonKeys = t1;
  let t2;
  if ($[2] !== formatMessage) {
    t2 = formatMessage("loadingAriaLabel");
    $[2] = formatMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles["bazaarvoice-review-loading__overview"]}><div className={styles["bazaarvoice-review-loading__distribution"]} /><div className={styles["bazaarvoice-review-loading__aggregate"]} /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== reviewSkeletonKeys) {
    t4 = reviewSkeletonKeys.map(_temp2);
    $[5] = reviewSkeletonKeys;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={styles["bazaarvoice-review-loading"]} role="status" aria-live="polite" aria-label={t2}>{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp2(reviewSkeletonKey) {
  return <div key={reviewSkeletonKey} className={styles["bazaarvoice-review-loading__review"]} />;
}
function _temp(_, position) {
  return `review-skeleton-${position}`;
}
export default memo(BazaarvoiceReviewLoadingComponent);